import { QuoteService } from './QuoteService'
import getTravelQuoteUaeResponse from '@/shared/tests/mocks/responses/gettravelquoteuae.json'

export class QuoteServiceMock extends QuoteService {
  async getTravelQuoteUae(): Promise<any> {
    return Promise.resolve(getTravelQuoteUaeResponse)
  }
}
